import VPageStudentViewRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageStudentViewRecord', VPageStudentViewRecord),
};
